import { render, staticRenderFns } from "./promoMenu.vue?vue&type=template&id=2abd03df&"
import script from "./promoMenu.vue?vue&type=script&lang=js&"
export * from "./promoMenu.vue?vue&type=script&lang=js&"
import style0 from "./promoMenu.vue?vue&type=style&index=0&id=2abd03df&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports